import React from 'react'
import './Navbar.css'
import { Link } from 'react-scroll'
export const Navbar = () => {
    return (
        <div className="navbar">
            <section>
                <div className="header">
                    &lt;<span style={{ color: "#65f4ad" }}>Ajinkya</span> Patil/&gt;
                </div>
            </section>
            <article>
                <div>
                    <Link activeClass="active" to="home" spy={true} smooth={true}>
                        <img className="img" src="https://img.icons8.com/material-sharp/24/000000/home.png" alt="" />
                        <div className="img-comp">Home</div>
                    </Link>
                </div>

                <div>
                    <Link activeClass="active" to="project" spy={true} smooth={true}>
                        <img className="img" src="https://img.icons8.com/material-outlined/24/000000/laptop.png" alt="" />
                        <div className="img-comp" >Projects</div>
                    </Link>
                </div>
                <div>
                    <Link activeClass="active" to="work" spy={true} smooth={true}>
                        <img className="img" src="https://img.icons8.com/external-kiranshastry-solid-kiranshastry/24/000000/external-flag-weapon-kiranshastry-solid-kiranshastry.png" alt="" />
                        <div className="img-comp" >Achievements</div>
                    </Link>
                </div>
            </article>
        </div>
    )
}


